import PropTypes from 'prop-types';
import React, {memo} from 'react';
import {useTranslation} from 'react-i18next';

export const NOTARIAL_PROCEDURE_TYPE = ['PROTOCOLIZING_ACT', 'AGREEMENT_ELEVATION', 'BOOK_ENABLES'];

const ProcedureNotarialProcedureType = ({value}) => {
  const {t} = useTranslation('company');
  
  if (!NOTARIAL_PROCEDURE_TYPE.includes(value))
    return (<>-</>);
  
  return (<>{t(`procedure.notaryProcedure.${value}`)}</>);
};

ProcedureNotarialProcedureType.propTypes = {
  className: PropTypes.string,
  full: PropTypes.bool,
  value: PropTypes.oneOf(NOTARIAL_PROCEDURE_TYPE),
  icon: PropTypes.any,
};

ProcedureNotarialProcedureType.defaultProps = {
  type: NOTARIAL_PROCEDURE_TYPE?.[0]
};

export default memo(ProcedureNotarialProcedureType);

/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Status component in a table cell
 * @param {String} type this is the value of the dataIndex of the table (we will ignored in this case)
 * */
export const renderProcedureNotarialProcedureType = (type) => {
  return (
    <ProcedureNotarialProcedureType value={type}/>
  );
};
